import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { BaseDetail } from "./base";
import { Files } from "./files";
import { MaterialInfo } from "./info";
import { LogisticsProcess } from "./process";
import { IShipmentTabEnum } from "../../shimentTypes";
import { useShipmentDetailModel } from "./shipmentDetailModel";
import { BoxDetail } from "./box";


export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive } = useShipmentDetailModel(({ tabActive }) => [tabActive]);

    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            // case IShipmentTabEnum.BASE_DETAIL:
            //     return <BaseDetail {...detailsInfo}/>;
            case IShipmentTabEnum.MATERIAL_INFO:
                return <MaterialInfo {...detailsInfo} />;
            case IShipmentTabEnum.FILES:
                return <Files {...detailsInfo} />;
            case IShipmentTabEnum.LOGISTICS_PROCESS:
                return <LogisticsProcess {...detailsInfo} />;
            case IShipmentTabEnum.BOX_INFO:
                return <BoxDetail {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: IShipmentTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }

    const action = <>
        <Button
            className={classname(IShipmentTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IShipmentTabEnum.BASE_DETAIL)}
        >基本信息</Button>
        <Button
            className={classname(IShipmentTabEnum.MATERIAL_INFO)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IShipmentTabEnum.MATERIAL_INFO)}
        >商品信息</Button>
        <Button
            className={classname(IShipmentTabEnum.BOX_INFO)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IShipmentTabEnum.BOX_INFO)}
        >装箱信息</Button>
        <Button
            className={classname(IShipmentTabEnum.FILES)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IShipmentTabEnum.FILES)}
        >附件管理</Button>
        <Button
            className={classname(IShipmentTabEnum.LOGISTICS_PROCESS)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IShipmentTabEnum.LOGISTICS_PROCESS)}
        >物流进程</Button>
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            {/* <div hidden={tabActive !== IShipmentTabEnum.BASE_DETAIL}><BaseDetail {...detailsInfo} /></div> */}
            <BaseDetail {...detailsInfo} />
            <RenderTabItem />
        </>
    )
}